const Helper = class _Helper {

    static formatDate(selectedDate) {
        const date = new Date(selectedDate);
        return [
            String(date.getFullYear()),
            String(date.getMonth() + 1).padStart(2, '0'),
            String(date.getDate()).padStart(2, '0')
        ].join(' '); // Join year, month, and day with a space
    }

    static validateDate(dateString) {
        return /^\d{4} \d{2} \d{2}$/.test(dateString);  // Matches format 'yyyy mm dd'
    }

    static isEmpty(value) {
        // Check for null, undefined, empty string, or whitespace-only string
        return value === null ||
            value === undefined ||
            (typeof value === 'string' && value.trim() === '') ||
            (Array.isArray(value) && value.length === 0) ||
            (typeof value === 'object' && Object.keys(value).length === 0);
    }

    static isValidPrice(value) {
        // Convert to number and check if it's finite and greater than or equal to zero
        const numberValue = Number(value);
        return Number.isFinite(numberValue) && numberValue > 0;
    }

    static getPageUrl({pageKey, endpointKey = '', args = {}}) {

        const pageSlug = ESR.options.slugs[pageKey];
        if (!pageSlug) {
            console.warn(`Slug not found for pageKey: ${pageKey}`);
            return '';
        }

        let url = `/${pageSlug}/`;
        if (endpointKey) {
            url += `${endpointKey}/`;
        }

        // Add query parameters if args is not empty
        if (Object.keys(args).length > 0) {
            const queryString = new URLSearchParams(args).toString();
            url += `?${queryString}`;
        }

        return window.location.origin + url;
    }

    static getProjectUrl(slug) {
        return this.getPageUrl({pageKey: 'project'}) + slug + '/'
    }

    static getProjectReportUrl(slug) {
        return this.getPageUrl({pageKey: 'project'}) + slug + '/report/'
    }

    static getReportUrl(endpoint, args = {}) {
        return this.getPageUrl({pageKey: 'reports', endpointKey: endpoint, args})
    }

    static getReportWorkerUrl({id, project_id = 0}) {
        const args = {};

        if (project_id) {
            args.project_id = project_id;
        }

        return ESR.Helper.getPageUrl({pageKey: 'worker', endpointKey: id, args});
    }

    static getPostAuthorID() {
        return ESR.post?.author_id ? parseInt(ESR.post.author_id) : 0
    }

    static getUserID() {
        return ESR.user?.id ? parseInt(ESR.user.id) : 0
    }

    static getUserRole() {
        return ESR.user?.role ?? ''
    }

    static canCreate() {
        return this.isManager() || this.isAdmin() || this.isSuperadmin()
    }

    static canEditOther() {
        return this.isAdmin() || this.isSuperadmin()
    }

    static userCan(capability) {
        return ESR?.user?.caps?.hasOwnProperty(capability) ? ESR.user.caps[capability] : false;
    }

    static isSuperadmin() {
        return this.getUserRole() === 'administrator'
    }

    static isAdmin() {
        return this.getUserRole() === 'admin'
    }

    static isManager() {
        return this.getUserRole() === 'manager'
    }

    static isWorker() {
        return this.getUserRole() === 'worker'
    }

    static isNotApproved() {
        return this.getUserRole() === 'subscriber'
    }

    static isPostAuthor() {
        return this.getUserID() === this.getPostAuthorID()
    }


    static select2DestroyAll(el) {
        el.find('select').each(function () {
            $(this).select2('destroy');
        });
    }

    static destroyDatepicker($input) {
        if ($input && $input.datepicker) {
            $input.datepicker('destroy');
        }
    }


    static validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email)
    }

    static validatePassword(password) {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
        return passwordRegex.test(password)
    }

    static toFloat(value) {
        const num = parseFloat(value);
        return isNaN(num) ? 0 : num;
    }

    static formatNumber(value, decimalPlaces = 2) {
        const num = parseFloat(value);
        if (isNaN(num)) return value;

        // Verifică dacă este număr întreg
        if (num % 1 === 0) {
            return num.toString();
        }

        // Pentru numere cu zecimale, formatează cu zecimalele specificate
        return num.toFixed(decimalPlaces);
    };

    static formatDecimal(value) {
        const num = parseFloat(value);
        if (isNaN(num)) return 0;

        const fixed = num.toFixed(2);
        return parseFloat(fixed).toString();
    }

    /**
     * Convert hours and minutes to decimal hours
     * @param {number} hours
     * @param {number} minutes
     * @returns {number} Decimal hours
     */
    static toDecimalHours(hours = 0, minutes = 0) {
        hours = parseFloat(hours) || 0;
        minutes = parseFloat(minutes) || 0;
        return hours + minutes / 60;
    }

    /**
     * Convert decimal hours to [hours, minutes]
     * @param {number} decimalHours
     * @returns {[number, number]} Array [hours, minutes]
     */
    static fromDecimalHours(decimalHours) {
        decimalHours = parseFloat(decimalHours) || 0;
        const hours = Math.floor(decimalHours);
        const minutes = Math.round((decimalHours - hours) * 60);
        return [hours, minutes];
    }


    static getConfigFormData(fieldConfigs) {
        const newData = {};

        fieldConfigs.forEach(config => {
            if (config.input && config.input.name) {
                const $input = $(`[name="${config.input.name}"]`);
                if ($input.length) {
                    // Pentru select multiple, ia array de valori
                    if (config.input.type === 'select' && $input.attr('multiple')) {
                        newData[config.input.name] = $input.val() || [];
                    } else if (config.input.type === 'number') {
                        newData[config.input.name] = parseFloat($input.val())
                    } else {
                        newData[config.input.name] = $input.val();
                    }
                }
            }
        });

        return newData;
    }

    static validateConfigField(value, fieldConfig) {
        const input = fieldConfig.input || {};
        const errors = fieldConfig.errors || {};

        // 1️⃣ Check required
        if (input.required && (value === undefined || value === null || String(value).trim() === '')) {
            return {isValid: false, message: errors.required || 'Acest câmp este obligatoriu.'};
        }

        // 2️⃣ Check pattern
        if (input.pattern) {
            const pattern = new RegExp(input.pattern);
            if (!pattern.test(String(value))) {
                return {isValid: false, message: errors.pattern || 'Valoare invalidă.'};
            }
        }

        // 3️⃣ Check min (numeric)
        if (input.type === 'number' && input.min !== undefined && Number(value) < input.min) {
            return {isValid: false, message: errors.min || `Valoarea minimă este ${input.min}.`};
        }

        // 4️⃣ Check max (numeric)
        if (input.type === 'number' && input.max !== undefined && Number(value) > input.max) {
            return {isValid: false, message: errors.max || `Valoarea maximă este ${input.max}.`};
        }

        return {isValid: true, message: ''};
    }


    static deepDiff(original, current) {
        // Same reference or primitive value
        if (original === current) return undefined;

        // Handle arrays
        if (Array.isArray(original) && Array.isArray(current)) {
            // If lengths differ, it's already a difference
            if (original.length !== current.length) return current;

            const result = [];
            let changed = false;

            for (let i = 0; i < original.length; i++) {
                const diff = this.deepDiff(original[i], current[i]);
                if (diff !== undefined) {
                    result[i] = diff;
                    changed = true;
                }
            }

            return changed ? result : undefined;
        }

        // Handle objects
        if (
            typeof original === "object" &&
            typeof current === "object" &&
            original !== null &&
            current !== null
        ) {
            const result = {};
            let changed = false;

            const keys = new Set([
                ...Object.keys(original),
                ...Object.keys(current)
            ]);

            for (const key of keys) {
                const diff = this.deepDiff(original[key], current[key]);
                if (diff !== undefined) {
                    result[key] = diff;
                    changed = true;
                }
            }

            return changed ? result : undefined;
        }

        // Primitive changed
        return current;
    }


}

export default Helper;